import { addressTokens, createTokens } from '@sail/engine';
import { customSpaceTokens } from './space';
import { customShadowTokens } from './shadow';
import { customTransitionTokens } from './transition';
import { customLetterSpacingTokens } from './typography';
import { customColorTokens } from './customColor';
import { customLayoutTokens } from './layout';
export const helmTokens = (()=>{
    const baseTokens = createTokens('helm', {
        transition: customTransitionTokens,
        color: customColorTokens,
        shadow: customShadowTokens,
        letterSpacing: customLetterSpacingTokens,
        space: customSpaceTokens,
        layout: customLayoutTokens
    });
    addressTokens(baseTokens);
    return baseTokens;
})();

//# sourceMappingURL=helmTokens.js.map